// @import dependencies
// @end

// @import event types
import {IMyCourse, IMyCourseTab} from 'app_types/campus/academic/myCoursesTypes'
import {ICoursesActionTypes, COURSE_SELECTED_CHANGE, COURSE_TAB_CHANGE} from './types'
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @add your events

/*===============================================
=            Estructura de un metodo            =
================================================
  // La estructura de un metodo debe ser la siguiente:
  export const methodName = () => {}
/*======  End of Estructura de un metodo  =====*/

export const courseSelectedChange = (course: IMyCourse | null): ICoursesActionTypes => {
  return {
    type: COURSE_SELECTED_CHANGE,
    payload: course,
  }
}

export const courseTabChange = (tab: IMyCourseTab | null): ICoursesActionTypes => {
  return {
    type: COURSE_TAB_CHANGE,
    payload: tab,
  }
}

//@end
